import BaseApi from "@/core/HttpResources/BaseApi";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
export default class AnnoucementService {
  baseApiPublish = new BaseApi("ResearchCenters");
  
  async getResearch(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAll",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async passRolToAnotherUser(userResearchCenter: UserResearchCenter) {
    var baseApi = new BaseApi("ResearchCenters/PassRolToAnotherUser");
    return new Promise<UserResearchCenter>((resolve, reject) =>
      baseApi.request(
        "PUT",
        String(),
        userResearchCenter,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
  async getCenterById(id: number) {
    var baseApi = new BaseApi("ResearchCenters/" + id);
    return new Promise<ResearchCenter>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getFacultiesById(id: number) {
    var baseApi = new BaseApi("ResearchCenters/GetFacultiesByUserId/" + id);
    return new Promise<ResearchCenter>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async deleteFaculty(id: number) {
    var baseApi = new BaseApi("Faculty/" + id);
    return new Promise<ResearchCenter>((resolve, reject) =>
      baseApi.request(
        "DELETE",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getFacultiesResearchCenterById(id: number) {
    var baseApi = new BaseApi("ResearchCenters/GetFacultiesByResearchCenterId/" + id);
    return new Promise<ResearchCenter>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getResearchCenterWithProvinces() {
    var baseApi = new BaseApi("ResearchCenters/ResearchCenterWithProvinces");
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getResearchCenterById(id: number) {
    var baseApi = new BaseApi("ResearchCenters/GetById/" + id);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
   getResearchById(id: number) {
    var baseApi = new BaseApi("GetResearchById/" + id);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }


  async getResearchCenterByCriteria(criteria: string) {
    var baseApi = new BaseApi("ResearchCenters/GetResearchCenterByCriteria/" + criteria);
    return new Promise<UserResearchCenter>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async searchByName(centerName:string): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "Get",
        "SearchByName/" + centerName,
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}